// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-header-root{--tlm-header-background:var(--v-primary-base);--tlm-logo-color:var(--v-secondary-base);--tlm-header-navigation-link:#fff;--tlm-header-navigation-link-active:var(--v-secondary-base);--tlm-header-divider:var(--v-primary-lighten1);--tlm-header-max-width:1056px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
